import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ToasterService, Toast } from './toaster.service';

@Component({
    selector: 'app-toaster',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './toaster.component.html',
})
export class ToasterComponent {
    protected toasterService = inject(ToasterService);

    trackByToastId(index: number, toast: Toast): string {
        return toast.id;
    }

    onCloseToast(id: string): void {
        this.toasterService.hide(id);
    }

    onActionClick(toast: Toast): void {
        if (toast.action) {
            toast.action.handler();
            this.toasterService.hide(toast.id);
        }
    }

    getToastClasses(status: string): string {
        const baseClasses = 'flex items-start gap-3 rounded-xl p-4 shadow-lg backdrop-blur-sm border';

        switch (status) {
            case 'success':
                return `${baseClasses} bg-green-50/95 dark:bg-green-900/95 text-green-800 dark:text-green-200 border-green-200 dark:border-green-700`;
            case 'error':
                return `${baseClasses} bg-red-50/95 dark:bg-red-900/95 text-red-800 dark:text-red-200 border-red-200 dark:border-red-700`;
            case 'warning':
                return `${baseClasses} bg-yellow-50/95 dark:bg-yellow-900/95 text-yellow-800 dark:text-yellow-200 border-yellow-200 dark:border-yellow-700`;
            case 'info':
                return `${baseClasses} bg-blue-50/95 dark:bg-blue-900/95 text-blue-800 dark:text-blue-200 border-blue-200 dark:border-blue-700`;
            case 'copy':
                return `${baseClasses} bg-blue-50/95 dark:bg-blue-900/95 text-blue-800 dark:text-blue-200 border-blue-200 dark:border-blue-700`;
            default:
                return `${baseClasses} bg-gray-50/95 dark:bg-gray-800/95 text-gray-800 dark:text-gray-200 border-gray-200 dark:border-gray-700`;
        }
    }

    getIconName(status: string): string {
        switch (status) {
            case 'success':
            case 'copy':
                return 'check';
            case 'error':
                return 'error';
            case 'warning':
                return 'warning';
            case 'info':
                return 'info';
            default:
                return 'info';
        }
    }

    getIconClasses(status: string): string {
        switch (status) {
            case 'success':
            case 'copy':
                return 'text-green-600 dark:text-green-400';
            case 'error':
                return 'text-red-600 dark:text-red-400';
            case 'warning':
                return 'text-yellow-600 dark:text-yellow-400';
            case 'info':
                return 'text-blue-600 dark:text-blue-400';
            default:
                return 'text-gray-600 dark:text-gray-400';
        }
    }
}
